import invoiceItemsList from '@/store/modules/user-interface/invoice-items-list';

export default {
  namespaced: true,
  modules: {
    invoiceItemsList,
  },
};
